import {DoodbeastContract} from "../DoodbeastContract";

export abstract class WalletService {
  abstract init(): Promise<DoodbeastContract>;
}
